module.exports = __webpack_public_path__ + "morocco.svg?43807c8dd4d458291c47dc529686773c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/morocco.svg
// module id = 238
// module chunks = 10